import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AddNewCoupon } from '../../redux/Slices/CouponSlice'
import notify from "./../UseNotification"

const UseAdminAddCoupon = () => {
    const DateRef = useRef();
    const dispatch = useDispatch()
    const { AddCoupon } = useSelector(state => state.CouponReducer)
    const [loading, setLoading] = useState()
    const [isPress, setIsPress] = useState(false)
    const [couponName, setCouponName] = useState('')
    const [couponDate, setCouponDate] = useState('')
    const [isFormValid, setIsFormValid] = useState(false)
    const [couponDiscountValue, setCouponDiscountValue] = useState('')

    // handle change coupon name
    const ChangeCouponName = (e) => {
        setCouponName(e.target.value)
    }


    // handle change coupon Date
    const ChangeCouponDate = (e) => {
        setCouponDate(e.target.value)
    }


    // get today date + selected date 
    let todayDate = new Date()
    let selectedDate = new Date(couponDate)

    // handle change coupon Date
    const ChangeCouponValue = (e) => {
        setCouponDiscountValue(e.target.value)
    }

    // validate the coupone name
    const ValidateCouponName = (e) => {
        if (e.target.value.length < 3) {
            notify("coupon name must at least 3 character", "error")
        }
    }

    // validate the coupone value
    const ValidateCouponValue = (e) => {
        if (e.target.value === "") {
            notify("please enter the coupon value", "error")
        }
    }
    // validate the coupone date
    const valiadteCouponDate = (e) => {
        if (e.target.value === "") {
            notify("please enter the coupon expire date", "error")
        } else if (todayDate > selectedDate) {
            notify("Selected date cannot be in the past", "error")
            return;
        }
        else {
            DateRef.current.type = "text"
        }
    }
    // to handle disable submit button
    useEffect(() => {
        if (couponName && couponDate && couponDiscountValue && couponName.length >= 3 && couponDate != "" && couponDiscountValue != "") {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [couponName, couponDate, couponDiscountValue])

    // handle submit add coupon
    const SubmitCoupon = async () => {
        setIsPress(true)
        if (couponName === "") {
            notify("enter the coupon name", "error")
            return;
        }
        else if (couponDate === "") {
            notify("enter the expire date", "error")
            return;
        }
        else if (couponDiscountValue === "") {
            notify("enter the coupon discount value", "error")
            return;
        }
        else if (todayDate > selectedDate) {
            notify("Selected date cannot be in the past", "error")
            return;
        }
        setLoading(true)
        await dispatch(AddNewCoupon({
            name: couponName,
            expire: couponDate,
            discount: couponDiscountValue
        }))
        setLoading(false)
    }

    // handle response after dispatch request 
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (AddCoupon && AddCoupon.data) {
                notify("Coupon created", "success")
                window.location.reload(false)
            } else if (AddCoupon && AddCoupon.response.status === 500) {
                notify("Duplicated Coupon, enter another Name", "error")
            } else if (AddCoupon && AddCoupon.response.status === 403) {
                notify("You are not allowed to add coupon", "error")
            }
        }
    }, [loading])
    return [isFormValid, DateRef, valiadteCouponDate, ValidateCouponName, ValidateCouponValue, isPress, loading, couponName, ChangeCouponName, couponDate, ChangeCouponDate, couponDiscountValue, ChangeCouponValue, SubmitCoupon]
}

export default UseAdminAddCoupon
